import script from "./AcademicSystemsEditor.vue?vue&type=script&setup=true&lang=js"
export * from "./AcademicSystemsEditor.vue?vue&type=script&setup=true&lang=js"

import "./AcademicSystemsEditor.vue?vue&type=style&index=0&id=59072636&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-59072636"]])

export default __exports__